import { isAnyBuyAndSellCategory, isAnyRealEstateCategory } from '@kijiji/category'
import { ResultsView } from '@kijiji/generated/graphql-types'

export const getSearchViewType = ({
  categoryId,
  isRadiusLocation,
  queryParamView,
  isGridViewEnabled,
}: {
  categoryId: number
  isRadiusLocation: boolean
  queryParamView?: string | string[]
  isGridViewEnabled?: boolean
}): ResultsView => {
  if (!queryParamView || typeof queryParamView !== 'string') return ResultsView.List

  const viewQuery = queryParamView.toUpperCase()

  /**
   * It should only allow grid view if the toggle is enabled
   * AND on buy and sell category
   */
  if (viewQuery === ResultsView.Grid && isGridViewEnabled && isAnyBuyAndSellCategory(categoryId)) {
    return ResultsView.Grid
  }

  /**
   * It should only allow map view on real estate categories
   * If it is a radius location
   */
  if (viewQuery === ResultsView.Map && isRadiusLocation && isAnyRealEstateCategory(categoryId)) {
    return ResultsView.Map
  }

  return ResultsView.List
}
